import { render } from "./emoji-nature.svg?vue&type=template&id=2fd48bf7?inline"
const script = {}
script.render = render

export default script